import TabPageItem from '@/molecules/TabsPage/TabPageItem';
import { sortedItems } from '@/organisms/NavBar/data/NavBar';
import clx from 'classnames';
import { useRouter } from 'next/router';
import { useMemo } from 'react';
import { MenuItemType } from 'types/cms';

type TabsPageProps = {
  items: MenuItemType[];
  className?: string;
};

const TabsPage = ({ items, className }: TabsPageProps) => {
  const { asPath } = useRouter();

  // Find the first matching item (items are sorted by href length, longest first)
  const activeItem = useMemo(() => sortedItems.find((item) => item.href && asPath.startsWith(item.href)), [asPath]);

  return (
    <ul className={clx('flex flex-row md:gap-4 w-full md:w-auto justify-around', className)}>
      {items.map((item, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <li key={`${index}li`}>
          <TabPageItem
            {...item}
            isActive={item.href ? asPath.startsWith(item.href) && activeItem?.href === item.href : item.selected}
          />
        </li>
      ))}
    </ul>
  );
};
export default TabsPage;
